import React, { useState } from 'react';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import { WhiteSpacePreservedTypography } from './TwExpandableText.styles';

export interface TwExpandableTextProps {
  /**
   * Text to display
   */
  text: string;
  /**
   * Number of character to limit
   */
  characterLimit: number;
}

const TwExpandableText: React.FC<TwExpandableTextProps> = ({
  text,
  characterLimit
}): JSX.Element => {
  const minimizedText = text.substring(0, characterLimit) + '...';
  const isOverCharLimit = minimizedText.length < text.length;
  const [isOpen, setIsOpen] = useState<boolean>(!isOverCharLimit);

  return (
    <Stack direction="column">
      <WhiteSpacePreservedTypography
        variant="subtitle2"
        fontWeight="400"
        color="#1F2937"
        fontSize="14px"
      >
        &quot;{isOpen ? text : minimizedText}&quot;
      </WhiteSpacePreservedTypography>

      {isOverCharLimit && (
        <Button
          variant="text"
          size="small"
          sx={{ textTransform: 'none', width: '75px', padding: '0px', color: '#3A4DE9' }}
          onClick={(): void => {
            setIsOpen(!isOpen);
          }}
        >
          Show {isOpen ? 'less' : 'more'}
        </Button>
      )}
    </Stack>
  );
};

export default TwExpandableText;
